module.exports = __webpack_public_path__ + "static/media/bkg01d.509c6848.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg01d.jpg
// module id = 463
// module chunks = 0